import {
  faChevronDown,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link, navigate } from 'gatsby'
import React, { useCallback, useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import Home from '../../../../src/common/assets/menu/icon_home.svg'
import menuItems, { MenuPrincipal, Route } from '../../constants/menu'
import { setMenuPrincipal } from '../../context/actions/menuActions'
import AppContext from '../../../../src/common/context/context'
import route from '../../../../src/common/utils/route'
import styles from './menuHeader.module.scss'
import { useSelector } from 'react-redux'
import { selectMenu } from '../../../../src/common/context/selectors/menuSelector'

const callRoute = (r: Route) => {
  if (typeof r === 'string') {
    return route(r)
  }
  const { path, ...rest } = r
  return route(path, rest)
}

interface LinkMenuProps {
  name: string
  r?: Route
  updateActive: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}
const LinkMenu = ({ name, r, updateActive }: LinkMenuProps) => {
  if (!r) {
    return <FormattedMessage id={name} />
  }
  if (name === 'menuHeader.c-acceso') {
    return (
      <a
        className={styles.submenu_item}
        href={r as string}
        target="_blank"
        rel="noreferrer">
        <FormattedMessage id={name} />
      </a>
    )
  }
  return (
    <Link
      className={styles.submenu_item}
      to={callRoute(r)}
      onClick={updateActive}>
      <FormattedMessage id={name} />
    </Link>
  )
}

export default function MenuHeader() {
  const { dispatch } = useContext(AppContext)
  const activeMenu = useSelector(selectMenu)

  const selectMenuPrincipal = useCallback(
    (menu: MenuPrincipal) => {
      dispatch(setMenuPrincipal(menu))
    },
    [dispatch]
  )
  return (
    <nav className={styles.header_menu}>
      <ul className={styles.header_menu_wrapper}>
        <li key="0" className={styles.dropdown}>
          <Link
            to="/"
            className={
              activeMenu === MenuPrincipal.HOME
                ? `${styles.dropbtn} ${styles.active}`
                : styles.dropbtn
            }
            onClick={() => selectMenuPrincipal(MenuPrincipal.HOME)}>
            <Home className={styles.home_icon} />
          </Link>
        </li>
        {menuItems.menu.map((item) => {
          if ('submenu' in item) {
            return (
              <li key={item.id} className={styles.dropdown}>
                <Link
                  onClick={() => {
                    selectMenuPrincipal(item.id)
                  }}
                  to={callRoute(item.route)}
                  className={
                    activeMenu === item.id
                      ? `${styles.dropbtn} ${styles.active}`
                      : styles.dropbtn
                  }>
                  <FormattedMessage id={item.name} />
                  <FontAwesomeIcon
                    icon={faChevronDown}
                    className={styles.chevron_icon}
                  />
                </Link>
                <div className={styles.dropdown_content}>
                  {item.submenu.map((submenu) => {
                    if ('submenu' in submenu) {
                      return (
                        <div
                          key={`${item.id}_${submenu.id}`}
                          className={styles.submenu_wrapper}>
                          <div className={styles.submenu_title}>
                            <FormattedMessage id={submenu.name} />
                          </div>
                          {submenu.submenu.map((submenuItem) => {
                            if (submenuItem.name === 'menuHeader.c-acceso') {
                              return (
                                <LinkMenu
                                  key={`${item.id}_${submenu.id}_${submenuItem.id}`}
                                  name={submenuItem.name}
                                  r={submenuItem.route}
                                  updateActive={() => {
                                    selectMenuPrincipal(item.id)
                                  }}></LinkMenu>
                              )
                            } else {
                              return (
                                <LinkMenu
                                  key={`${item.id}_${submenu.id}_${submenuItem.id}`}
                                  name={submenuItem.name}
                                  r={submenuItem.route}
                                  updateActive={() => {
                                    selectMenuPrincipal(item.id)
                                  }}></LinkMenu>
                              )
                            }
                          })}
                          {item.name === 'menuHeader.neumaticos' &&
                          submenu.id === 3 ? (
                            <button
                              className={styles.button_buscador}
                              onClick={() => {
                                navigate(route('selector.medidas'))
                              }}>
                              <FormattedMessage id="menuHeader.buscador_neumatico" />
                              <FontAwesomeIcon
                                icon={faChevronRight}
                                className={styles.button_buscador_icon}
                              />
                            </button>
                          ) : null}
                          {item.name === 'menuHeader.revisiones' &&
                          submenu.id === 3 ? (
                            <button
                              className={styles.button_buscador}
                              onClick={() =>
                                navigate(route('revisiones.asistente'))
                              }>
                              <FormattedMessage id="menuHeader.asistente_revision" />
                              <FontAwesomeIcon
                                icon={faChevronRight}
                                className={styles.button_buscador_icon}
                              />
                            </button>
                          ) : null}
                        </div>
                      )
                    } else {
                      return (
                        <LinkMenu
                          key={`${item.id}_${submenu.id}`}
                          name={submenu.name}
                          r={submenu.route}
                          updateActive={() => {
                            selectMenuPrincipal(item.id)
                          }}></LinkMenu>
                      )
                    }
                  })}
                </div>
              </li>
            )
          } else {
            return (
              <li key={item.id} className={styles.dropdown}>
                <Link
                  onClick={() => {
                    selectMenuPrincipal(item.id)
                  }}
                  to={callRoute(item.route)}
                  className={
                    activeMenu === item.id
                      ? `${styles.dropbtn} ${styles.active}`
                      : styles.dropbtn
                  }>
                  <FormattedMessage id={item.name} />
                </Link>
              </li>
            )
          }
        })}
      </ul>
    </nav>
  )
}
